import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SubscriptionContext = createContext(null);

// Pages that require a full (paid or trial) subscription.
export const PREMIUM_PATHS = [
  "journal", "insights", "habits", "goals", "lifestory", "memories", "growth", "community",
];

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/subscription/status");
      setSub(data);
      return data;
    } catch {
      setSub(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (user) refresh();
    else setLoading(false);
  }, [user, refresh]);

  const premium = !!sub?.premium;

  return (
    <SubscriptionContext.Provider value={{ sub, premium, loading, refresh }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export const useSubscription = () => useContext(SubscriptionContext);
